import { AxiosRequestConfig } from "axios";

import { getInstance } from "./instance";
import { setVersionedUrl } from "./utils";

export type RequestConfig = AxiosRequestConfig & {
  skipCamelization?: boolean;
  apiVersion?: number;
  skipVersioning?: boolean;
};

const api = <T = any>(config: RequestConfig) => {
  setVersionedUrl(config);

  return getInstance()<T>(config).then((res) => res.data);
};

export default api;
